export const blockIconsHomeCleaningBucketNew = (
	<span className='material-symbols-outlined'>cleaning_bucket</span>
);
